import { render, staticRenderFns } from "./technicalField.vue?vue&type=template&id=1c6ffc5c&scoped=true"
import script from "./technicalField.vue?vue&type=script&lang=js"
export * from "./technicalField.vue?vue&type=script&lang=js"
import style0 from "./technicalField.vue?vue&type=style&index=0&id=1c6ffc5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ffc5c",
  null
  
)

export default component.exports